import SelectField from '../shared/SelectField'
import {
  ESTATE_CONDITION_OPTIONS,
  COMMERCIAL_CONDITION_OPTIONS,
} from 'store/CreatePropertyAdSlice/constants'
import React from 'react'
import {
  useWatch,
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../'

interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues?: UseFormGetValues<FormValues>
  resetField?: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const EstateCondition = (props: Props) => {
  const { control } = props

  const watchCategory = useWatch({ control, name: 'step1.category' })

  return (
    <>
      <SelectField
        options={
          watchCategory === 'estate'
            ? ESTATE_CONDITION_OPTIONS
            : COMMERCIAL_CONDITION_OPTIONS
        }
        title="createPropertyAdFields.estateCondition.label"
        translateTitle
        titleProps={{ required: false }}
        control={control}
        name={'property.estateCondition' as Path<FormValues>}
      />
    </>
  )
}

export default React.memo(EstateCondition)
